import Conversations from 'pages/chatbot-settings/conversations/index.jsx';
import GeneralSettings from 'pages/chatbot-settings/bot-settings';
import ChatInterfaceSettings from 'pages/chatbot-settings/chat-interface';
import AccessibilitySettings from 'pages/chatbot-settings/accessibility';
import EmbedOnSite from 'pages/chatbot-settings/embed-on-site';
import ChatBotList from 'pages/chatbot-list';
import ChatbotDemo from 'pages/chatbot-settings/chatbot-preview';
import DataSource from 'pages/chatbot-settings/data-source';
import MyAccount from 'pages/account/index';
import Pricing from 'pages/pricing';
import ReportPage from 'pages/reports';

export const routes = [
  {
    key: 'chatbot',
    title: 'Chatbot',
    route: '/chatbot',
    auth_required: true,
    is_base_route: true,
    component: ChatbotDemo,
  },
  {
    key: 'chatbots',
    title: 'My Chatbots',
    route: '/chatbots',
    auth_required: true,
    is_base_route: true,
    component: ChatBotList,
  },
  {
    key: 'conversations',
    title: 'Conversations',
    route: '/conversations',
    auth_required: true,
    is_base_route: false,
    component: Conversations,
  },
  {
    key: 'embed-on-site',
    title: 'Embed On Site',
    route: '/embed-on-site',
    auth_required: true,
    is_base_route: false,
    component: EmbedOnSite,
  },
  {
    key: 'settings',
    title: 'Settings',
    route: '/settings',
    auth_required: true,
    is_base_route: false,
    component: GeneralSettings,
  },
  {
    key: 'chat-interface',
    title: 'Chat Interface',
    route: '/chat-interface',
    auth_required: true,
    is_base_route: false,
    component: ChatInterfaceSettings,
  },
  {
    key: 'accessibility',
    title: 'Access Control',
    route: '/access-control',
    auth_required: true,
    is_base_route: false,
    component: AccessibilitySettings,
  },
  {
    key: 'data-source',
    title: 'Data Source',
    route: '/data-source',
    auth_required: true,
    is_base_route: false,
    component: DataSource,
  },
  {
    key: 'add-data-source',
    title: 'Data Source',
    route: '/add-data-source',
    auth_required: true,
    is_base_route: true,
    component: DataSource,
  },
  {
    key: 'pricing',
    title: 'Pricing',
    route: '/pricing',
    auth_required: true,
    is_base_route: true,
    component: Pricing,
  },
  {
    key: 'my-account',
    title: 'My Account',
    route: '/account',
    auth_required: true,
    is_base_route: true,
    component: MyAccount,
  },
  {
    key: 'reports',
    title: 'Reports',
    route: '/reports',
    auth_required: true,
    is_base_route: true,
    component: ReportPage,
  },
];
